<div class="container text-center pt-5 h-100">
    <img src="assets/images/logo.svg" class="mb-5" alt="Logo">
    <h3>U heeft uw e-mailadres nog niet bevestigd</h3>
    <p>
        wij hebben een bevestigingslink verstuurd naar <span class="font-weight-bold">{{user.email}}</span><br><br>
        klik op de link in deze e-mail om uw account te activeren
    </p>

    <div class="logout" (click)="logout()">&laquo; Naar het inlogscherm</div>
</div>